export const environment = {
    apiBaseUrl:
    'https://data-api.gavesha.space:8443/api',
    // 'https://data-api.gavesha.space/api',
    production: true,
    firebaseConfig: {
        apiKey: 'AIzaSyCZOsxKeOvK45oD3KqgScVTyxrLsVPzbwc',
        authDomain: 'devdata.gavesha.space',
        projectId: 'weatherkids-dev-67016',
        storageBucket: 'weatherkids-dev-67016.appspot.com',
        messagingSenderId: '970886652672',
        appId: '1:970886652672:web:8a0792b56136ac678789e5',
    },
};
